import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { asMaybeasy } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import { L, NotTranslated, T } from '../../../../Translations';
import { ProductLicenseResource, ProductLicensesResource } from './Decoder';

interface Props {
  insightIndex: number;
  productLicenses: ProductLicensesResource;
}

function ProductLicense({ insightIndex, productLicenses }: Props) {
  const labelFor = (productLicense: ProductLicenseResource, index: number) => {
    const targetId = `homepage-insight-${insightIndex}-license-${index}-label`;

    return asMaybeasy(productLicense.payload.publicName)
      .map((publicName) => (
        <span
          className="font-light text-xs bg-[#187a90] text-white px-1 py-1 mx-1 rounded-sm"
          data-intercom-target={targetId}
        >
          <NotTranslated text={publicName} />
        </span>
      ))
      .getOrElse(emptyFragment);
  };

  return productLicenses.payload.map((productLicense, index) => (
    <Typography
      as="div"
      key={productLicense.payload.id}
      variant="bodySmall"
      className="mb-1"
      color="dark"
    >
      <NotTranslated text={productLicense.payload.name} />
      {labelFor(productLicense, index)} (
      <T
        kind="Expires <date/>"
        date={<L localizeable={productLicense.payload.endOn} format={'short-month-day-year'} />}
      />
      )
    </Typography>
  ));
}

export default observer(ProductLicense);
